<template>
	<system v-if="isOpen" class="system system--beacon-list">
		<ElementHeadlineBig content="Beacon List" />

		<div v-for="[id, beacon] of Object.entries(beaconDescription)" :key="id">
			<ElementSetting
				class="beacon-bias-input"
				name="bias"
				:content="`${beacon.major}:${beacon.minor}`"
				type="number"
				inputmode="numeric"
				pattern="[0-9]*"
				:value="beacon.bias"
				:update="value => updateBeaconBias(id, value)"
			/>
		</div>
	</system>
</template>
<script>
import { mapMutations } from 'vuex';
import UiBase from '../ui/base.vue';
import { mutationTypes } from '../../types';
import { uiComponents } from '../../tools/viewState';
import { mapStateNested } from '../../tools/helpers';

export default {
	extends: UiBase,
	data() {
		return {
			name: uiComponents.systemBeaconList,
		};
	},
	computed: {
		...mapStateNested('bluetooth', ['beaconDescription']),
		beaconList() {
			return Object.values(this.beaconDescription);
		},
	},
	methods: {
		...mapMutations([mutationTypes.bluetoothSetBeaconDescription]),
		updateBeaconBias(id, bias) {
			const updatedBeacon = {
				...this.beaconDescription[id],
				bias,
			};
			const beaconDescription = {
				...this.beaconDescription,
				[id]: updatedBeacon,
			};

			this.bluetoothSetBeaconDescription({ beaconDescription });
		},
	},

	created() {
		this.mutations = mutationTypes;
		this.bluetoothSetScanConfig = mutationTypes.bluetoothSetScanConfig;
		this.nearestBeaconSetConfig = mutationTypes.nearestBeaconSetConfig;
		this.areaBeaconSetConfig = mutationTypes.areaBeaconSetConfig;
	},
};
</script>
<style lang="sass">
.beacon-bias-input input
	font-size: 2em !important
</style>
